import { Route, Routes, Outlet } from "react-router-dom";
import SSOAuthScreen from "../screens/Authentication/SSOAuthScreen";
import CommonDashboard from "../screens/common/CommonDahboard";

const routes = [
  {
    path: "/",
    element: <SSOAuthScreen />,
  },
  {
    path: "/dashboard/*",
    element: <CommonDashboard />,
  },
];

export default () => {
  return (
    <>
      <Routes>
        {routes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>
      <Outlet />
    </>
  );
};
